import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { ApplicantStepComponent } from './applicant-step.component';
import { StepResolverService } from '../../../services';

export const applicantStepRoute: Route = {
  path: RouteIds.applicant,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.applicant) },
  component: ApplicantStepComponent,
};
